import { useQuery, UseQueryResult } from "@tanstack/react-query";

import * as config from "@/config";

import { hermesFetch, HermesApiError } from "./hermes-fetch";
import { useHermesApiToken } from "./use-hermes-api-token";

export interface InsightsThread {
  group_id: string;
  threads: {
    user_id: string;
    resolved: number;
    total: number;
    unresolved: number;
    deleted: number;
  }[];
}

/**
 * Hook to fetch the Threads Insights data from Hermes.
 */
export function useThreadInsights(
  assessmentId: string,
  workId: string,
  studentIds: string[]
): UseQueryResult<InsightsThread[]> {
  const apiToken = useHermesApiToken({ assessmentId, workId });
  return useQuery(
    [`insights/threads`, studentIds],
    async () => {
      const hermesUrl = `${config.HERMESV2_ENDPOINT}/api/insights/threads`;

      return hermesFetch<InsightsThread[]>(hermesUrl, apiToken, {
        method: "POST",
        body: JSON.stringify({
          user_ids: studentIds,
          group_ids: [],
        }),
      });
    },
    {
      cacheTime: 100,
      refetchInterval: false,
      useErrorBoundary: (error) =>
        error instanceof HermesApiError && error.status === 401,
      enabled: !!apiToken,
    }
  );
}
